import React from 'react';

import createSvgIcon from '../Utils/CreateSvgIcon';

export const Card = createSvgIcon(
  <React.Fragment>
    <path
      d="M4 7L20 7L20 8L4 8V7ZM4 11V17L20 17L20 11L4 11ZM2 7C2 5.89543 2.89543 5 4 5L20 5C21.1046 5 22 5.89543 22 7L22 17C22 18.1046 21.1046 19 20 19L4 19C2.89543 19 2 18.1046 2 17V7Z"
      fillRule="evenodd"
    />
    <path
      d="M3.9986 6L20 6L4 6C3.99953 6 3.99907 6 3.9986 6ZM21 9L3 9V10L21 10L21 9ZM20 7L20 8L4 8V7L20 7ZM4 17V11L20 11L20 17L4 17ZM4 5C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19L20 19C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H4Z"
      fillRule="evenodd"
    />
  </React.Fragment>,
  'Card',
);
